import validate from "validate.js";

export default validate;
